import React from "react";
import MenuPage from "../components/MenuPage";

const News = () => {  

  return (
    <div className="w-full">
      <MenuPage/>          
      </div>
    
  );
};

export default News;
